.container {
  display: flex;
  align-items: center;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    padding: 0.4rem;
  }
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  font-weight: 500;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.6rem;
    font-weight: 600;
  }
}

.position {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--color-grayscale-light-slate);

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
    font-weight: 500;
  }
}
